import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['resourceBtn', 'modal'];

  connect() {
    this.#initializeModal();
  }

  #initializeModal() {
    this.resourceBtnTargets.forEach((btn) => {
      btn.addEventListener('click', () => {
        new bootstrap.Modal(this.modalTarget).show();
        this.#updateModalContent(btn);
      });
    });
  }

  #updateModalContent(btn) {
    const resourceIconImageUrl = btn.dataset.iconImageUrl;
    const resourceName = btn.dataset.name;
    const resourceDescription = btn.dataset.description;
    const libraryName = btn.dataset.category;

    document.getElementById('resourceIconImage').src = resourceIconImageUrl;
    document.getElementById('resourceIconImage').alt = resourceName;
    document.getElementById('resourceName').innerHTML = resourceName;
    document.getElementById('resourceDescription').innerHTML = resourceDescription;

    document.querySelectorAll('.js-library-name').forEach((badge) => {
      badge.innerHTML = libraryName;
    });
  }
}
